import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import Marquee from "../components/Marquee";
import { BUSINESS, restaurantLd, breadcrumbLd } from "../data/business";

const CHAPTERS = [
  {
    no: "01",
    title: "Lahir di tengah Kota Hujan",
    body: `Bakso Tujuh Pemuda membuka pintunya pada ${BUSINESS.established} di Jalan Pengadilan, jantung Bogor Tengah — persis di seberang Sekolah Regina Pacis. Konsepnya mengambil semangat gerai makanan tradisional dengan sentuhan kekinian: area makan yang luas, nyaman untuk keluarga maupun rombongan teman.`,
  },
  {
    no: "02",
    title: "Tetelan goreng, bukan tetelan rebus",
    body: "Di sinilah kami berbeda. Tetelan sapi kami digoreng hingga renyah di luar namun tetap gurih lumer di dalam — menggantikan tetelan rebus biasa dan menjadikan semangkuk bakso terasa lebih spesial. Tambahkan sambal berbahan cabai rawit dan bawang untuk yang berani pedas.",
  },
  {
    no: "03",
    title: "Dapur terbuka, kuah selalu hangat",
    body: "Dapur kami dilapisi dinding kaca. Anda bisa melihat langsung mie diaduk, kuah dituang, dan adonan bakso digoreng. Setiap menu diracik fresh setelah dipesan, dan kuah kaldu dijaga selalu hangat maksimal agar pengalaman menyeruput lebih nikmat.",
  },
  {
    no: "04",
    title: "Halal dan terbuka untuk semua",
    body: "Seluruh menu kami telah bersertifikat halal sebagaimana diumumkan melalui kanal resmi kami pada Desember 2025. Dengan area makan yang luas dan parkir yang memadai, semua orang dipersilakan datang dan merasa seperti di rumah.",
  },
];

export default function TentangPage() {
  return (
    <>
      <Seo
        title="Tentang Bakso Tujuh Pemuda — Bakso Hangat Andalan Keluarga Bogor"
        description="Kenali Bakso Tujuh Pemuda: rumah makan bakso di Bogor Tengah yang buka sejak Mei 2025, dengan dapur terbuka, tetelan goreng khas, dan sertifikasi halal."
        path="/tentang/"
        jsonLd={[restaurantLd, breadcrumbLd([{ name: "Beranda", path: "/" }, { name: "Tentang", path: "/tentang/" }])]}
      />
      <PageHeader
        crumb="Tentang"
        eyebrow={`Sejak ${BUSINESS.established}`}
        lines={[<>Tentang <span className="italic font-semibold text-terracotta">Bakso Tujuh Pemuda</span></>]}
      />
      <section className="py-16 sm:py-24" data-testid="tentang-page">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <Reveal className="lg:sticky lg:top-32">
                <div className="rounded-[2.5rem] rounded-tl-[6rem] overflow-hidden border-4 border-ink shadow-[12px_12px_0_0_#E68A2E]">
                  <img
                    src={BUSINESS.images.interior}
                    alt="Suasana area makan yang luas dan nyaman di Bakso Tujuh Pemuda"
                    width="1400"
                    height="933"
                    loading="lazy"
                    className="w-full aspect-[4/5] object-cover"
                  />
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-7">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.05}>
                  <article className="border-t border-line py-10 first:border-t-0 first:pt-0" data-testid={`tentang-chapter-${c.no}`}>
                    <span className="font-display font-black text-5xl sm:text-6xl text-terracotta/20">{c.no}</span>
                    <h2 className="mt-2 font-display font-black tracking-tight text-2xl sm:text-3xl">{c.title}</h2>
                    <p className="mt-4 text-ink-soft leading-relaxed">{c.body}</p>
                  </article>
                </Reveal>
              ))}
              <Reveal>
                <Link to="/menu/" data-testid="tentang-menu-link" className="group mt-4 inline-flex items-center gap-2 font-bold text-terracotta">
                  Lihat apa yang kami sajikan
                  <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
      <Marquee />
    </>
  );
}
